import { Field } from '@sitecore-jss/sitecore-jss-vue';
import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';

export enum RacqProductStatus {
  Active = 'active',
  Scheduled = 'scheduled',
  Cancelled = 'cancelled',
  Paid = 'paid',
}

export interface IIProductStatus {
  message: string;
  productStatus: RacqProductStatus;
  showButton?: boolean;
  showPayNowButton?: boolean;
  payButtonText?: string;
  renewButtonText?: string;
  renewalOfferFormLink?: Field<LinkFieldValue>;
  makeAPaymentLink?: Field<LinkFieldValue>;
  policyNumber?: string;
  prn?: string;
  dataTestId?: string;
}
